import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';


@Injectable()
export class MailService {

  constructor(
    private afs:AngularFirestore,) { }

    enviarMailDePrueba(){
      let mail = {
        to: 'tppshaka77@gmail.com',
        from: "Trösten Transport <sales@gmail.com>",
        message: {
          html: "<p>Mensaje demo</p>",
          subject: "Información de la Cotización",
        }
      }

        try {
          return this.afs.collection('mail').add(mail)
        } catch (error) {
          console.log(error);
          return error
        }
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/mail.service.ts